export const initialState = () => ({
  filters: [],
  reason: {
    type: "",
    description: "",
    categorie: ""
  },
  uuid: ""
})
